var _defs, _g, _text, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _polyline, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04SoftwareServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 37,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 273.23px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #042b62;\n      }\n\n      .cls-4 {\n        fill: #bababa;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n\n      .cls-6 {\n        fill: #fefefe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M771.27,476.14c.02,7.8-1.43,10.28-9.89,10.23-67.97-.41-135.94-.23-203.91-.22-24.96,0-35.23,10.31-35.23,35.29,0,102.41-.02,204.82.06,307.22,0,2.24.08,4.27-.3,6v164c0,3-1.16,5.72-3.07,7.75-2.06,2.21-5.01,3.59-8.27,3.59H160.34c-4.96,0-9.18-3.19-10.72-7.63-.66-1.63-.87-3.82-.87-6.71.24-135.01.17-270.02.17-405.02s.08-270.02-.17-405.03c-.01-8.18,1.7-10.94,10.48-10.82,38.75.52,77.51.06,116.26.37,6.77.06,9.06-1.6,8.87-8.67-.5-18.13.07-36.29-.3-54.43-.13-6.16,1.88-7.85,7.87-7.72,17.52.35,35.07.42,52.58-.03,6.72-.17,8.21,2.25,8.08,8.45-.35,18.14.07,36.29-.23,54.43-.1,5.9,1.5,8.09,7.76,7.96,18.44-.39,36.9-.34,55.35-.02,5.78.1,7.31-1.94,7.23-7.45-.28-18.45.1-36.91-.23-55.35-.1-5.83,1.26-8.16,7.6-8.01,17.21.41,34.45.31,51.66.04,5.25-.08,6.92,1.64,6.84,6.86-.26,18.14.31,36.3-.28,54.42-.26,7.93,2.41,9.77,9.89,9.54,17.82-.53,35.69-.59,53.5.02,8.04.28,9.69-2.57,9.48-9.95-.5-17.82.02-35.67-.27-53.5-.1-5.56,1.47-7.52,7.24-7.41,17.22.34,34.45.35,51.67,0,5.84-.12,7.27,1.98,7.18,7.46-.28,17.52.3,35.07-.28,52.58-.27,8.16,1.68,10.96,10.46,10.85,41.52-.49,83.04,0,124.56-.41,7.85-.08,9.56,2.28,9.54,9.78-.25,97.18-.26,194.36.01,291.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M547.67,756.68c0-72.55,0-145.11,0-217.66,0-18.59,11.72-30.66,30.32-30.68,60.57-.07,121.17-1.1,181.7.47,43.93,1.14,87.85.43,131.76,1.4,28.86.64,40.07,11.43,40.11,40.46.17,141.42.18,282.84.17,424.26,0,16.29-15.02,31.39-31.29,31.41-107.3.08-214.61.09-321.91,0-16.6-.02-30.85-14.68-30.85-31.05,0-72.86,0-145.72,0-218.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M740.7,705.85c-43.02,0-86.04,0-129.07,0-11.23,0-13.68-2.22-13.7-13.15-.07-36.26-.07-72.52,0-108.77.02-9.41,3.39-12.88,12.61-12.87,58.69.04,117.41-.76,176.07.64,28.53.68,57.07.76,85.6,1.33,6.37.13,9.35,1.44,9.48,8.67.66,37.13,2.85,74.23,1.99,111.39-.25,11.02-1.81,12.75-13,12.76-43.33.03-86.66.01-129.99.01Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(206.76 422.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 771,
    y: 771,
    width: 89,
    height: 21
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 609,
    y: 775,
    width: 89,
    height: 21
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 609,
    y: 775,
    width: 89,
    height: 21,
    transform: "translate(1439 132) rotate(90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 609,
    y: 899,
    width: 89,
    height: 21,
    transform: "translate(798.45 -201.01) rotate(43.13)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 609,
    y: 899,
    width: 89,
    height: 21,
    transform: "translate(1764.01 1054.45) rotate(133.13)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 771,
    y: 881,
    width: 89,
    height: 21
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 771,
    y: 917,
    width: 89,
    height: 21
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202,
    y: 517,
    width: 272.44,
    height: 35.73
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202,
    y: 587.34,
    width: 230.01,
    height: 35.73
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202,
    y: 657.87,
    width: 159.67,
    height: 33.13
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "313 927.5 397.09 855 443.42 891.5 518.34 830"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 399.25,
    cy: 854.25,
    r: 16.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 198.75,
    cy: 927.75,
    r: 13.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 248.75,
    cy: 926.75,
    r: 13.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 316.25,
    cy: 921.25,
    r: 16.75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 445.25,
    cy: 887.25,
    r: 16.75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 511.25,
    cy: 834.25,
    r: 16.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04SoftwareServices);
export default __webpack_public_path__ + "static/media/04SoftwareServices.5212834809ebb339fd5fbdd9e0435d0d.svg";
export { ForwardRef as ReactComponent };